import { createStore } from 'vuex';
// PERSISTED IN LOCALSTORAGE
// import createPersistedState from 'vuex-persistedstate';
import appstore from './appstore';
import contenttreestore from './contenttreestore';
import assemblystore from './assemblystore';
import publicindexstore from './publicindexstore';
import profilestore from './profilestore';
import peerreviewstore from './peerreviewstore';
// ✅ Create a Singleton Store
const store = createStore({
    modules: {
        appstore,
        profilestore,
        assemblystore,
        peerreviewstore,
        contenttreestore,
        publicindexstore,
    },
    strict: !!process.env.DEBUGGING,
    // PERSISTED IN LOCALSTORAGE
    // plugins: [createPersistedState()],
});
export default store; // ✅ Export a SINGLE instance
